import React from 'react';
import { Package, ShoppingCart, Box, DollarSign, Users, XCircle, AlertTriangle, CheckCircle, RefreshCw } from 'lucide-react';
import { StatCard, MktBadge, Badge, Th, Td } from '../WMSShared';

export default function DashboardTab({ stats, orders, alerts, load, switchTab, cur = 'S$' }) {
  return (
    <div>
      <div className="flex items-center justify-between mb-6">
        <h2 className="text-xl font-bold text-gray-900">Dashboard Overview</h2>
        <button onClick={load} className="flex items-center gap-2 text-sm text-gray-500 hover:text-gray-700">
          <RefreshCw className="w-4 h-4" />Refresh
        </button>
      </div>
      <div className="grid grid-cols-2 lg:grid-cols-5 gap-4 mb-8">
        <StatCard label="Products" value={stats.total_products} icon={Package} color="blue" sub={`${stats.low_stock || 0} low stock, ${stats.out_of_stock || 0} out`} />
        <StatCard label="Total Stock" value={stats.total_stock?.toLocaleString()} icon={Box} color="emerald" sub={`Value: ${cur}${(stats.inventory_value || 0).toLocaleString()}`} />
        <StatCard label="Units Sold" value={stats.total_sold?.toLocaleString()} icon={ShoppingCart} color="purple" sub={`${stats.total_orders || 0} orders`} sub2="+12% this month" />
        <StatCard label="Revenue" value={`${cur}${(stats.total_revenue || 0).toLocaleString()}`} icon={DollarSign} color="orange" sub={`${stats.pending_orders || 0} pending`} sub2="+8% this month" />
        <StatCard label="Customers" value={stats.total_customers} icon={Users} color="pink" sub="Across all marketplaces" />
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
        <div className="lg:col-span-2 bg-white rounded-xl border shadow-sm">
          <div className="flex items-center justify-between px-5 py-4 border-b">
            <h3 className="font-semibold">Recent Orders</h3>
            <button className="text-sm text-blue-600" onClick={() => switchTab('orders')}>View all</button>
          </div>
          <div className="overflow-x-auto">
            <table className="w-full text-sm">
              <thead className="bg-gray-50"><tr><Th>Order</Th><Th>Customer</Th><Th>Marketplace</Th><Th>Total</Th><Th>Status</Th></tr></thead>
              <tbody className="divide-y">
                {orders.slice(0, 6).map(o => (
                  <tr key={o.order_id} className="hover:bg-gray-50">
                    <Td className="font-mono text-xs">{o.order_id}</Td>
                    <Td>{o.customer_name}</Td>
                    <Td><MktBadge m={o.marketplace} /></Td>
                    <Td className="font-medium">{cur}{o.grand_total || o.total}</Td>
                    <Td><Badge status={o.status} /></Td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
        <div className="bg-white rounded-xl border shadow-sm">
          <div className="px-5 py-4 border-b"><h3 className="font-semibold">Stock Alerts</h3></div>
          <div className="divide-y max-h-80 overflow-y-auto">
            {alerts.map(p => (
              <div key={p.product_id || p.sku} className="flex items-center justify-between px-4 py-3">
                <div className="flex items-center gap-2">
                  {p.stock === 0 ? <XCircle className="w-4 h-4 text-red-500 shrink-0" /> : <AlertTriangle className="w-4 h-4 text-amber-500 shrink-0" />}
                  <div><p className="text-sm font-medium leading-tight">{p.name}</p><p className="text-[10px] text-gray-400">{p.sku}</p></div>
                </div>
                <span className={`text-xs font-semibold ${p.stock === 0 ? 'text-red-600' : 'text-amber-600'}`}>{p.stock === 0 ? 'Out' : p.stock}</span>
              </div>
            ))}
            {alerts.length === 0 && (
              <div className="p-6 text-center text-gray-400">
                <CheckCircle className="w-6 h-6 mx-auto mb-1" /><p className="text-xs">All healthy</p>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
